import { isEmpty, map } from "lodash";
import { useEffect } from "react";

// import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import ProductCard from "components/product/card/ProductCard";
import styles from "./carousel.module.scss";
import { Carousel } from "antd";

const PrevArrow = ({ onClick }) => {
  return (
    <button
      className={`${styles.carouselArrow} ${styles.arrowPrev}`}
      onClick={onClick}
    >
      <img src="https://instance5.admin.grandus.sk/files/attachment/2020-11/6469/5f4cb5/arrow-left.svg" />
    </button>
  );
};

const NextArrow = ({ onClick }) => {
  return (
    <button
      className={`${styles.carouselArrow} ${styles.arrowNext}`}
      onClick={onClick}
    >
      <img src="https://instance5.admin.grandus.sk/files/attachment/2020-11/6472/09fa27/arrow-right.svg" />
    </button>
  );
};

const ProductsCarousel = ({ products }) => {
  if (isEmpty(products)) {
    return "";
  }

  const settings = {
    dots: true,
    infinite: false,
    // speed: 500,
    slidesToScroll: 1,
    slidesToShow: 6,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
        },
      },
    ],
  };

  return (
      <section className={`productSlider ${styles.productSliderWrapper} `}>
        <Carousel {...settings} className="productCarousel" arrows>
          {map(products, (product, index) => {
            return (
              <div key={`products-${product.id}-${index}`}>
                <ProductCard
                  {...product}
                  options={{
                    style: { wrapperClasses: [styles?.productCard] },
                  }}
                />
              </div>
            );
          })}
        </Carousel>
      </section>
  );
};

export default ProductsCarousel;
